export * from './use-delete-template-category'
